var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":"purple","type":"info"}},[_c('div',{staticClass:"alert"},[_vm._v(" "+_vm._s(_vm.$t('alert-google'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }